import '../../../Styles/Layout/MiniDisplays/SwitchToggle.css';

interface SwitchToggleProps {
  isChecked: boolean;
  setIsChecked: (value: boolean) => void;
  disabled?: boolean;
}

const SwitchToggle: React.FC<SwitchToggleProps> = ({
  isChecked,
  setIsChecked,
  disabled = false,
}) => {
  return (
    <label className={`select-toggle ${disabled ? 'disabled' : ''}`}>
      <input
        type="checkbox"
        checked={isChecked}
        onChange={() => {
          if (!disabled) {
            setIsChecked(!isChecked);
          }
        }}
        disabled={disabled}
      />
      <span className="toggle-slider"></span>
    </label>
  );
};

export default SwitchToggle;